<template>
    <section class="p-3 position-relative" id="visit-attachments-upload-hc">
        <div class="position-absolute top-0 end-0 pt-2 pe-2">
            <button type="button" class="btn-close" aria-label="close" @click="cancel()"></button>
        </div>
        <h6 class="text-center fw-bold">File Attachment:</h6>
        <div class="w-100 mb-3">
            <div class="custom-file">
                <label for="upload-document" class="custom-file-label upload-file-name">Choose File</label>
                <input
                    type="file"
                    name="Attachment"
                    ref="file1"
                    @change="uploadFilesChanged($event)"
                    :disabled="isSaving"
                    id="upload-document"
                    class="custom-file-input valid"
                />
            </div>
            <div class="d-flex align-items-center" v-if="attachment">
                <a class="me-0">
                    <i class="fa fa-paperclip new-paperclip"></i>
                    <span class="ms-1">{{ attachment.name }}</span>
                </a>
                <button type="button" @click="removeAttachedFile()" class="btn table-btn btn-outline-danger">
                    <i class="fas fa-trash-alt"></i>
                </button>
            </div>
        </div>
        <template v-for="[, information] in uploadedDocumentationType" :key="information.name">
            <div
                class="d-none"
                v-if="information.value === uploadedDocumentationTypeEnum.None || !showDocumentTypes"
            ></div>
            <template v-else>
                <div class="form-check align-items-center px-0" v-if="displayDocumentType(information.value)">
                    <input
                        type="radio"
                        class="me-1"
                        name="UploadedDocumentationType"
                        :id="`uploadedDocumentationType_${information.name}`"
                        :value="information.value"
                        :checked="documentType === information.value"
                        @click="documentTypeChanged(information.value)"
                    />
                    <label :for="`uploadedDocumentationType_${information.name}`">
                        <span class="me-1">{{ information.longDescription }}</span>
                    </label>
                </div>
            </template>
        </template>
        <div class="d-flex justify-content-center mt-2 p-2">
            <span v-if="isSaving">
                <button class="btn btn-primary" type="button">
                    <i class="fa fa-spinner fa-spin animated slow flash infinite"></i>
                </button>
            </span>
            <span v-else>
                <button class="btn btn-primary" @click="saveAttachment()">Save</button>
            </span>
        </div>
    </section>
</template>

<script lang="ts" src="./VisitAttachmentsUploadHC.ts" />
<style lang="scss" src="./VisitAttachmentsUploadHC.scss" />
